export const workData = {
  employmentType: {
    value: 'Employment',
    label: 'Работа по найму',
    data: {
      alias: 'Employment',
    },
  },
  isWorkOrganizationManuallyFilled: false,
  workOrganizationName: 'ООО "СРАВНИ.РУ"',
  workAddress: {
    value: 'г Москва, б-р Энтузиастов, д 2',
    label: 'г Москва, б-р Энтузиастов, д 2',
    data: {
      fias_level: '8',
      region_fias_id: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
      region_with_type: 'г Москва',
      city_fias_id: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
      fias_id: '5154132f-ce8b-413a-b600-be04232eed64',
      city_with_type: 'г Москва',
      street_fias_id: '1230221a-fee2-4c47-93ac-c9ffd453daf5',
      street_with_type: 'б-р Энтузиастов',
      settlement_fias_id: null,
      settlement_with_type: null,
      house_fias_id: '5154132f-ce8b-413a-b600-be04232eed64',
      house: '2',
      dadata: 'г Москва, б-р Энтузиастов, д 2',
      unrestricted_value: '109544, г Москва, Таганский р-н, б-р Энтузиастов, д 2',
    },
  },
  workLocationRoute: '6.83.',
  lastWorkExperienceStartMonth: '03.2020',
  employerInn: '7710718303',
  jobTitle: {
    value: 'Разработчик по',
    label: 'Разработчик по',
    data: {
      type: 'Specialist',
      position: 'Разработчик по',
    },
  },
  workPhone: '79999123321',
  employerType: {
    value: 'OOO',
    label: 'ООО',
    data: {
      alias: 'OOO',
      meta: '12300',
    },
  },
  areaOfEmployment: {
    value: 'TradeServicesCommunications',
    label: 'Сфера торговли, услуг, связи',
    data: {
      alias: 'TradeServicesCommunications',
      meta: '45-47,55-63,77-82,95-98',
    },
  },
  monthlySalary: 50_000,
  unemploymentReason: null,
  anotherUnemploymentReason: '',
};
